"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storySchema = exports.timelinesSchema = void 0;
const yup_1 = require("yup");
const base_1 = require("../base");
const consts_1 = require("../consts");
// String schema
const charSlotId = (0, yup_1.mixed)();
const animationKey = (0, yup_1.mixed)();
const timelineId = (0, yup_1.mixed)();
const stepId = (0, yup_1.mixed)();
const characterColors = (0, base_1.OneOf)(consts_1.labelColors);
const validCDNUrl = (0, yup_1.string)().test('isValidCDNUrl', (v) => Boolean(v && v.startsWith('https://cms.characters')));
const validAssemblerNUrl = (0, yup_1.string)().test('validAssemblerNUrl', (v) => Boolean(v && v.startsWith('https://sverse-character-storage') && v.includes('assembler')));
const validAnimationUrl = (0, yup_1.string)().test('validAnimationUrl', (v) => validCDNUrl.isValidSync(v) || validAssemblerNUrl.isValidSync(v));
const characterAnimationsTest = {
    name: 'characterAnimationsTest',
    message: "characterAnimationsTest has failed validation",
    test: (value) => {
        if (!value) {
            return false;
        }
        const testKeys = Object.keys(value).every(k => (0, yup_1.string)().isValidSync(k) && k.startsWith('a_') && k.endsWith('.json'));
        const testValues = Object.values(value).every(v => (0, yup_1.string)().isValidSync(v) && validAnimationUrl.isValidSync(v));
        const isValid = testValues && testKeys;
        if (!isValid) {
            console.error('Error: characterAnimationsTest', {
                testKeys,
                testValues
            });
        }
        return isValid;
    }
};
const characterAnimations = (0, yup_1.mixed)().test(characterAnimationsTest);
const charMetadataSchema = (0, yup_1.object)({
    id: (0, yup_1.string)().required(),
    name: (0, yup_1.string)().required(),
    color: characterColors.required(),
    skeleton: (0, yup_1.string)().required(),
    skin: (0, yup_1.string)().required(),
    animations: characterAnimations.required(),
    tokenId: (0, yup_1.string)().required(),
    contractAddress: (0, yup_1.string)().required(),
    attributes: (0, yup_1.string)().default(undefined),
    version: (0, yup_1.string)().default(undefined),
}).noUnknown();
const charLayoutSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
    scale: (0, yup_1.number)().required(),
    zIndex: base_1.int.required(),
    dir: (0, yup_1.number)().oneOf(consts_1.directions).required(),
    layer: base_1.int.required(),
}).noUnknown();
const charSlotSchema = (0, yup_1.object)({
    id: charSlotId.required(),
    layout: charLayoutSchema.required(),
    disabledOnStart: (0, yup_1.boolean)().default(undefined),
    displayName: (0, yup_1.string)().default(undefined),
    charMetadata: charMetadataSchema.required(),
    overrideable: (0, yup_1.boolean)().default(undefined),
}).noUnknown();
const charSlots = (0, yup_1.mixed)();
const parallaxLayerSchema = (0, yup_1.object)({
    image: (0, yup_1.string)().required(),
    width: (0, yup_1.number)().default(undefined),
    height: (0, yup_1.number)().default(undefined),
    x: (0, yup_1.number)().default(undefined),
    y: (0, yup_1.number)().default(undefined),
}).noUnknown();
const parallaxSchema = (0, yup_1.object)({
    width: (0, yup_1.number)().required(),
    height: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
    layers: (0, yup_1.array)().of(parallaxLayerSchema).required(),
}).noUnknown();
const direction = (0, base_1.OneOf)(consts_1.directions);
const bubbleLayoutSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
    dirX: direction.required(),
    dirY: direction.required(),
    tailOffset: (0, yup_1.number)().default(undefined),
}).noUnknown();
const bubbleSchema = (0, yup_1.object)({
    mode: (0, base_1.OneOf)(consts_1.bubbleModes).default(undefined),
    tagname: (0, yup_1.string)().default(undefined),
    tagcolor: characterColors.default(undefined),
    charSlotId: charSlotId.default(undefined),
    layout: bubbleLayoutSchema.required(),
    caption: (0, yup_1.string)().required()
}).noUnknown();
const choiceOptionSchema = (0, yup_1.object)({
    caption: (0, yup_1.string)().required(),
    toTimeline: timelineId.required(),
}).noUnknown();
const choicesSchema = (0, yup_1.mixed)();
const cameraPreset = (0, base_1.OneOf)(consts_1.cameraPresets);
const cameraMotionSchema = (0, yup_1.object)({
    ease: (0, base_1.OneOf)(consts_1.cameraEases).default(undefined),
    duration: (0, yup_1.number)().default(undefined),
    zoom: (0, yup_1.number)().default(undefined),
    easeParams: (0, yup_1.mixed)().default(undefined),
    // not be used in current specs but could easily be added:
    // x: number().optional(),
    // y: number().optional(),
    // not sure we want to enable this one, it may break a few things:
    // rotation: number().optional(),
});
const cameraSchema = (0, yup_1.object)({
    charSlotId: charSlotId.default(undefined),
    preset: cameraPreset.default(undefined),
    motions: (0, yup_1.object)({
        // camera motion to the specified preset
        toPreset: cameraMotionSchema.default(undefined),
        // camera motion that starts with the character speech
        alongSpeech: cameraMotionSchema.default(undefined),
        // example of other possible motions:
        // camera motion that loops throughout the character speech
        // throughoutSpeech: cameraMotionSchema.optional(),
        // camera motion that starts when the character speech has ended
        // postSpeech: cameraMotionSchema.optional(),
    }).default(undefined),
}).noUnknown();
const charPosSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().default(undefined),
    y: (0, yup_1.number)().default(undefined),
}).noUnknown();
const charMotionPosSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
}).noUnknown();
const charMotionSchema = (0, yup_1.object)({
    to: charMotionPosSchema.default(undefined),
    speed: (0, yup_1.number)().required(),
    type: (0, base_1.OneOf)(consts_1.characterMotionTypes).default(undefined),
}).noUnknown();
const gestureSchema = (0, yup_1.object)({
    charSlotId: charSlotId.required(),
    dirX: direction.default(undefined),
    animation: animationKey.default(undefined),
    loop: (0, yup_1.boolean)().default(undefined),
    charPos: charPosSchema.default(undefined),
    charMotion: charMotionSchema.default(undefined),
    visible: (0, yup_1.boolean)().default(undefined),
}).noUnknown();
const gestures = (0, yup_1.mixed)();
const stepSchema = (0, yup_1.object)({
    prevStep: stepId.default(undefined),
    nextStep: stepId.default(undefined),
    gestures: gestures.required(),
    parallax: parallaxSchema.default(undefined),
    camera: cameraSchema.default(undefined),
    bubble: bubbleSchema.default(undefined),
    // If it's the last step of a timeline (if not the last step of the whole story) it must have either choices or toTimeline
    choices: choicesSchema.default(undefined),
}).noUnknown();
const steps = (0, yup_1.mixed)();
const timelineSchema = (0, yup_1.object)({
    root: timelineId.required(),
    lastStep: stepId.required(),
    firstStep: stepId.required(),
    // toTimeline can be set when timeline doesnt have choices
    toTimeline: timelineId.default(undefined),
    // mergeTimeline is set when the timeline has choices
    mergeTimeline: timelineId.default(undefined),
    steps: steps.required(),
}).noUnknown();
exports.timelinesSchema = (0, yup_1.mixed)();
const revealType = (0, yup_1.mixed)();
const revealScheduleSchema = (0, yup_1.object)({
    timestamp: (0, yup_1.number)().required(),
    revealedTimelineId: timelineId.required(),
    type: revealType.required(),
    revealed: (0, yup_1.boolean)().required(),
});
const storyMetadataSchema = (0, yup_1.object)({
    timestamp: base_1.uint.required(),
    version: base_1.uint.required(),
    saveCount: base_1.int.required(),
    editedBy: (0, base_1.OneOf)(consts_1.editedBy).required(),
    templateIndex: (0, yup_1.string)().default(undefined),
    revealSchedule: revealScheduleSchema.default(undefined),
}).noUnknown();
const choicesMade = (0, yup_1.mixed)();
const bookmarkSchema = (0, yup_1.object)({
    timelineId: timelineId.required(),
    stepId: stepId.required(),
    label: (0, yup_1.string)().required(),
});
exports.storySchema = (0, yup_1.object)({
    filterPreset: (0, base_1.OneOf)(consts_1.filterPresets).required(),
    charSlots: charSlots.required(),
    metadata: storyMetadataSchema.required(),
    rootTimelineId: timelineId.required(),
    timelines: exports.timelinesSchema.required(),
    choicesMade: choicesMade.required(),
    revealedTimelineId: timelineId.default(undefined),
    bookmarks: (0, yup_1.array)().of(bookmarkSchema),
}).noUnknown();
//# sourceMappingURL=story.js.map